import * as React from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { logUserOut } from './logoutReducer';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { StyledLogout } from './styles';
import { gaEvent } from '../../../utils/google-analytics';
import { ga4Event } from '../../../utils/google-analytics-4';
import { useTheme } from 'styled-components';

export const UserLogout = (props) => {
  const { oktaAuth } = useOktaAuth();
  const theme = useTheme();
  const logout = async () => {
    ga4Event({ category: 'logout', action: 'click' });
    props.dispatch(logUserOut());
    oktaAuth.signOut((props.affiliatedCarrierAccess ? { postLogoutRedirectUri:  window.location.protocol + '//' + window.location.host + '?carrier=' + theme.carrierName }: "/"));
    // this prevents AuthApiError on logout which is browser specific
    // and caused during session invalidation
    sessionStorage.removeItem('okta-token-storage');
    // sessionStorage.removeItem('okta-cache-storage');
    // localStorage.removeItem('okta-token-storage');
    // localStorage.removeItem('okta-shared-transaction-storage');
    // localStorage.removeItem('okta-cache-storage');
  };

  return (
    <StyledLogout
      id="logOut"
      onClick={() => logout()}
      onKeyPress={() => logout()}
      role="button"
      tabIndex={0}
    >
      Log Out
    </StyledLogout>
  );
};
UserLogout.propTypes = {
  dispatch: PropTypes.any,
  affiliatedCarrierAccess: PropTypes.bool,
};
export const mapStateToProps = (state) => ({
  state,
  affiliatedCarrierAccess: state.configurationSlice.features.features.affiliatedCarrierAccess,
});
export default connect(mapStateToProps)(UserLogout);
